import $ from 'jquery';
document.addEventListener('DOMContentLoaded', function () {
    $(document.body).on('click', '[data-popup]', function(e) {
        var pop = document.querySelector($(this).data('popup'))
        if (!pop) {
            return
        }
        pop.showModal();
    })

    $(document.body).on('click', '[data-popup-close]', function(e) {
        e.target.closest('dialog').close();
    })

    $(document.body).on('click', 'dialog', function(e) {
        if (e.target !== e.currentTarget) {
            return
        }

        let rect = e.target.getBoundingClientRect();
       	if (rect.left > e.clientX ||
            rect.right < e.clientX ||
            rect.top > e.clientY ||
            rect.bottom < e.clientY
        ) {
            e.target.close();
        }
    })

    // // Add an event listener to the dialog element
    // dialog.addEventListener("click", ({ target: clickedElement }) => {
    //   // If the clicked element is the dialog itself (meaning the backdrop was clicked)
    //   if (clickedElement.nodeName === "DIALOG") {
    //     dialog.close(); // Close the dialog
    //   }
    // });
});

function akaCloseModal(event) {

}
